import { distanceInWordsToNow } from 'date-fns';
import { useRouter } from 'found';
import { useQuery } from '@apollo/client';
import get from 'lodash/get';
import Button from '@mui/material/Button';
import ListItem from '@mui/material/ListItem';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CommunitiesIcon from '@mui/icons-material/Group';
// import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Sticky from 'react-sticky-box';

import HTMLFragment from 'components/HTMLFragment';
import Image from 'components/Image';
import {
  getEventPartyDate,
  // getParticipantState,
} from 'lib/eventUtils';
// import { navigateTo } from 'lib/navigateTo';
import useIsMobile from 'lib/useIsMobile';

import { useTheme } from '@mui/material';
import moment from 'moment';
import InfiniteScrollerApollo from '../../components/InfiniteScrollerApollo';
import ProfilePage from './Page';
import { GET_PARTICIPATION_HISTORY } from '../../schema/apolloQueries/profileQueries';
import { convertToLocalDate } from '../../utils/helper';

const pageSize = 10;

const ProfileParticipationPage = () => {
  const theme = useTheme();
  const styles = useMemo(
    () => ({
      communityChevron: {
        marginRight: 16,
        alignSelf: 'center',
      },
      communityContainer: {
        marginBottom: 10,
        width: '100%',
      },
      eventChevron: {
        marginRight: 0,
        marginBottom: 0,
        alignSelf: 'center',
        // backgroundColor: 'transparent',
      },
      eventFooter: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-end',
      },
      eventListItem: {
        zIndex: 900,
      },
      image: {
        objectFit: 'contain',
      },
      imageContainer: {
        width: '20%',
        minWidth: 120,
        margin: 10,
      },
      innerDiv: {
        flex: 1,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
      },
      listItem: {
        marginBottom: 10,
        backgroundColor: theme.palette.background.paper,
      },
      listItemLast: {
        marginBottom: 0,
      },
      sticky: {
        zIndex: 1000,
      },
      textDiv: {
        padding: 10,
        flex: 1,
      },
      partyDateLabel: {
        fontWeight: 600,
        paddingBottom: '8px',
      },
    }),
    [theme],
  );
  const bgColors = useMemo(
    () => [
      theme.palette.primary.light,
      theme.palette.secondary.light,
      theme.palette.warning.light,
      theme.palette.info.light,
      theme.palette.success.light,
      theme.palette.error.light,
    ],
    [theme],
  );
  const mobile = useIsMobile();
  const { router } = useRouter();
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const endText = 'Click here to find a new community to join';
  const communityClick = useCallback(
    community => router.push(`/communities/${community?.slug}`),
    [router],
  );
  const destinationClick = useCallback(
    destination => router.push(`/events/${destination}`),
    [router],
  );
  const emptyClick = useCallback(() => router.push('/discover/communities'), [
    router,
  ]);
  const { data, fetchMore } = useQuery(GET_PARTICIPATION_HISTORY, {
    variables: {
      page: 1,
      size: pageSize,
    },
  });

  const handleFetchMore = (isPage, setHasMore) => {
    return new Promise((reslove, reject) => {
      fetchMore({
        variables: {
          page: isPage,
          size: pageSize,
        },
        updateQuery: (pre, { fetchMoreResult }) => {
          if (
            pre?.getParticipationHistory.data?.length
            >= fetchMoreResult?.getParticipationHistory?.total
          ) {
            setHasMore(false);
          } else {
            setHasMore(true);
          }
          return pre?.getParticipationHistory?.data?.length
            >= fetchMoreResult?.getParticipationHistory?.total
            ? pre
            : {
              getParticipationHistory: {
                __typename: pre.getParticipationHistory.__typename,
                total: pre.getParticipationHistory.total,
                data: [
                  ...pre.getParticipationHistory.data,
                  ...fetchMoreResult.getParticipationHistory.data,
                ],
              },
            };
        },
      })
        .then(() => {
          reslove();
        })
        .catch(() => {
          reject();
        });
    });
  };

  const [sponsorIdEventList, setSponsorIdEventList] = useState([]);
  const getSponsorsList = () => {
    const sponsorIdEventListLoc = [];
    const eventList = data?.getParticipationHistory.data;
    eventList?.forEach(ele => {
      const sponsorIndex = sponsorIdEventListLoc.findIndex(s => s.sponsorId === ele.sponsorId);
      if (
        sponsorIndex === -1
      ) {
        sponsorIdEventListLoc.push({
          sponsorId: ele.sponsorId,
          sponsorImage: ele.sponsor?.assetResponse?.hlsPlaylistUrl,
          sponsorName: ele.sponsor.name,
          memberSince: ele.memberSince,
          slug: ele.sponsor.slug,
          events: [ele],
        });
      } else {
        let oldEventList = sponsorIdEventListLoc[sponsorIndex].events;
        oldEventList = [...oldEventList, ele];
        sponsorIdEventListLoc[sponsorIndex].events = oldEventList;
      }
    });
    setSponsorIdEventList(sponsorIdEventListLoc);
  };
  useEffect(() => {
    if (data?.getParticipationHistory.data) {
      getSponsorsList();
      setIsFirstLoad(false);
    }
  }, [data?.getParticipationHistory.data]);

  const renderEvent = useCallback(
    (event, last) => {
      // const {
      //   cta,
      //   destination,
      //   label,
      // } = getParticipantState(
      //   event,
      //   false,
      //   true,
      // );
      const partyDateLabel = getEventPartyDate(event);
      // const isPartySetupDest = destination?.type !== 'party-setup';
      // if (destination?.type === 'event-activities') {
      //   destination.type = 'event-details';
      // }
      const { slug } = event;
      const label = event.participationType;
      return (
        <ListItem
          key={event.id}
          style={{
            ...styles.listItem,
            ...(last ? styles.listItemLast : {}),
          }}
        >
          <div style={styles.innerDiv}>
            <div style={styles.textDiv}>
              <HTMLFragment>{event.name}</HTMLFragment>
              <div>
                {partyDateLabel && (
                  <div style={styles.partyDateLabel}>
                    {partyDateLabel || "Sorry, you weren't selected."}
                  </div>
                )}
                <div>{label}</div>
              </div>
            </div>
          </div>
          <div style={styles.eventFooter}>
            {slug && (
              <Button
                endIcon={<ChevronRightIcon />}
                onClick={() => destinationClick(slug)}
                primary
                style={styles.eventChevron}
              >
                View Event
              </Button>
            )}
          </div>
        </ListItem>
      );
    },
    [
      destinationClick,
      styles.eventChevron,
      styles.eventFooter,
      styles.innerDiv,
      styles.listItem,
      styles.listItemLast,
      styles.partyDateLabel,
      styles.textDiv,
    ],
  );
  const renderCommunity = (community, i) => {
    const bgColor = bgColors[i % bgColors.length];
    return (
      <div
        key={community.sponsorId}
        style={{
          ...styles.communityContainer,
          borderLeft: `10px solid ${bgColor}`,
        }}
      >
        <Sticky offsetTop={mobile ? 48 : 117} style={styles.sticky}>
          <ListItem
            onClick={() => communityClick(community)}
            style={{
              ...styles.listItem,
              ...(community?.events.length === 0 ? styles.listItemLast : {}),
            }}
          >
            <div style={styles.innerDiv}>
              <div style={styles.imageContainer}>
                <Image
                  src={get(community, 'sponsorImage')}
                  style={styles.image}
                />
              </div>
              <div style={styles.textDiv}>
                <HTMLFragment>{community?.sponsorName}</HTMLFragment>
                {moment(community?.memberSince).isValid() && (
                  <div>
                    Joined{' '}
                    {distanceInWordsToNow(
                      convertToLocalDate(community.memberSince),
                    )}{' '}
                    ago
                  </div>
                )}
              </div>
              <ChevronRightIcon
                color='#726D6D'
                style={styles.communityChevron}
              />
            </div>
          </ListItem>
        </Sticky>
        {community?.events?.length > 0
          ? community?.events.map((node, j) => renderEvent(node, j === community.events.length - 1))
          : null}
      </div>
    );
  };

  return (
    <ProfilePage title='Participation'>
      <InfiniteScrollerApollo
        handleFetchMore={handleFetchMore}
        isFirstLoad={isFirstLoad}
        isEmpty={data?.getParticipationHistory?.data?.length === 0}
        doneButtons={(
          <Button
            variant='contained'
            startIcon={<CommunitiesIcon />}
            onClick={emptyClick}
            primary
          >
            {endText}
          </Button>
        )}
        emptyText={endText}
        emptyTitle="You haven't joined any communities yet"
        onEmptyClick={emptyClick}
      >
        {sponsorIdEventList.map(renderCommunity)}
      </InfiniteScrollerApollo>
    </ProfilePage>
  );
};

// ProfileParticipationPage.propTypes = {
//   viewer: PropTypes.object.isRequired,
// };

export default ProfileParticipationPage;
